import React from "react";
import "./styles/Careers.css"

export class Careers extends React.Component{
    render() {
        return(
            <div className="careers"></div>
        )
    }
}